import { render, staticRenderFns } from "./cSocialList.vue?vue&type=template&id=d9a0cb34&scoped=true&"
import script from "./cSocialList.vue?vue&type=script&lang=js&"
export * from "./cSocialList.vue?vue&type=script&lang=js&"
import style0 from "./cSocialList.vue?vue&type=style&index=0&id=d9a0cb34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a0cb34",
  null
  
)

export default component.exports